import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=6156b992&scoped=true&"
import script from "./Sorting.vue?vue&type=script&lang=js&"
export * from "./Sorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156b992",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectComponent: require('/home/bitrix/frontend/components/form/SelectComponent.vue').default})
